import { combineReducers } from 'redux';
import loginReducer from './loginReducer';
import menuReducer from './menuReducer';
import dataFolderReducer from './dataFolderReducer';
import detailSearchReducer from './detailSearchReducer';
import documentReducer from './DocumentReducer';
import documentsearchbarReducer from './documentsearchbarReducer';
import systemInfoReducer from './systemInfoReducer';
import dashboardReducer from './dashboardReducer';

const rootReducer = combineReducers({
  login: loginReducer,
  menu: menuReducer,
  datafolder: dataFolderReducer,
  detailsearch: detailSearchReducer,
  document: documentReducer,
  documentsearchbar: documentsearchbarReducer,
  systemInfo: systemInfoReducer,
  dashboard: dashboardReducer,
});

export default rootReducer;
